import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const MAP = {
  Available: "bg-emerald-100 text-emerald-800 border-emerald-200",
  "In Service": "bg-blue-100 text-blue-800 border-blue-200",
  Sold: "bg-zinc-200 text-zinc-700 border-zinc-300",
  Pending: "bg-amber-100 text-amber-800 border-amber-200",
  Missing: "bg-red-100 text-red-800 border-red-200",
};

export default function StatusBadge({ status }) {
  return (
    <Badge
      variant="outline"
      className={cn("font-semibold rounded-md border", MAP[status] || "bg-zinc-100 text-zinc-700 border-zinc-200")}
      data-testid={`status-badge-${status}`}
    >
      {status}
    </Badge>
  );
}
